import { useEffect, useCallback } from "react";

export const useBroadcastChannel = (channelName: string, onMessage: (data: any) => void) => {
    useEffect(() => {
        const broadcastChannel = new BroadcastChannel(channelName);

        const handleMessage = (event: MessageEvent) => {
            onMessage(event.data);
        };

        broadcastChannel.addEventListener("message", handleMessage);

        return () => {
            broadcastChannel.removeEventListener("message", handleMessage);
            broadcastChannel.close();
        };
    }, [channelName, onMessage]);

    const broadcast = useCallback(
        (data: unknown) => {
            const broadcastChannel = new BroadcastChannel(channelName);
            broadcastChannel.postMessage(data);
            broadcastChannel.close();
        },
        [channelName]
    );

    return { broadcast };
};
